import React, { useRef } from 'react'
import { List, Popper } from '@material-ui/core'
import { ICaptionOption } from '../../types/datafile'
import { useOutsideClick } from './hooks'
import { P } from '../StyledText'
import { StyledListCaption, StyledListItem, StyledPaper } from './styled'

export interface IOptionsList {
  open: boolean
  anchorEl: Element
  listOptions: ICaptionOption[]
  onSelect: (value: string) => void
  onClose: () => void
}

export const OptionsList = ({
  open,
  anchorEl,
  onSelect,
  onClose,
  listOptions,
}: IOptionsList) => {
  const wrapperRef = useRef(null)
  useOutsideClick(wrapperRef, onClose, open)
  return (
    <Popper open={open} anchorEl={anchorEl} style={{ zIndex: 100 }}>
      <div ref={wrapperRef}>
        <StyledPaper>
          <List component="nav">
            {listOptions.map(({ value, label, isCaption }) => (
              <StyledListItem
                button
                key={value}
                disabled={isCaption}
                onClick={() => onSelect(value)}
                titled={isCaption}
              >
                {isCaption ? (
                  <StyledListCaption>{label}</StyledListCaption>
                ) : (
                  <P>{[value, label].join(' - ')}</P>
                )}
              </StyledListItem>
            ))}
          </List>
        </StyledPaper>
      </div>
    </Popper>
  )
}
